import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const registerEventInterest = async (orgId: string, eventId: string) => {
  const response = await axiosClient.post(
    `${orgId}/events/${eventId}/interest`,
  );
  return response.data;
};

export function useRegisterEventInterest(
  orgId: string,
  eventId: string,
  options?: Partial<UseMutationOptions<void, HttpError, void>>,
) {
  return useMutation({
    mutationFn: () => registerEventInterest(orgId, eventId),
    ...options,
  });
}
